<!-- HEADER -->
<header class="header" [class.scrolled]="scrolled">
  <div class="header-container">
    <div class="logo" (click)="scrollToSection('hero')">
      <img src="assets/img/icone-cloud.svg" alt="FT Pilot Logo" class="logo-icon">
      <span class="logo-text">FT PILOT</span>
    </div>

    <nav class="nav" [class.open]="isMenuOpen">
      <a (click)="scrollToSection('hero')" class="nav-link">MINHA GARAGEM</a>
      <a (click)="scrollToSection('about')" class="nav-link">COMUNIDADE</a>
      <a (click)="scrollToSection('shop')" class="nav-link">LOJA</a>
      <a (click)="scrollToSection('footer')" class="nav-link">SUPORTE</a>
      <a class="nav-link">TERMOS DE USO</a>
      <a class="nav-link">POLÍTICA DE PRIVACIDADE</a>
    </nav>

    <div class="header-actions">
      <button class="search-btn">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
      </button>
      <div class="lang-selector-header">
        <div class="lang-dropdown-header">
          <span>🌐 {{ selectedLanguage.name }}</span>
          <div class="lang-options-header">
            <a *ngFor="let lang of languageOptions" (click)="changeLanguage(lang)">{{ lang.name }}</a>
          </div>
        </div>
      </div>
      <button class="btn-enter" (click)="login()">ENTRAR</button>
      <button class="mobile-menu-toggle" (click)="toggleMenu()">
        <span></span><span></span><span></span>
      </button>
    </div>
  </div>
</header>

<main>
  <!-- HERO SECTION -->
  <section id="hero" class="hero">
    <!-- Background com linhas diagonais -->
    <div class="hero-bg-lines"></div>
    
    <!-- Cloud icon decorativo -->
    <div class="cloud-icon-decoration">
      <img src="assets/img/icone-cloud.svg" alt="Cloud" class="cloud-icon">
    </div>

    <div class="hero-grid">
      <div class="hero-content reveal fade-left">
        <h1 class="hero-title">ORGANIZE, COMPARTILHE<br>E EVOLUA SEUS PROJETOS<br>COM O <span class="highlight">FT PILOT.</span></h1>
        <div class="hero-buttons">
          <button class="btn-register" (click)="signUp()">Registrar Usuário</button>
          <a (click)="scrollToSection('about')" class="link-saiba-mais">Saiba mais</a>
        </div>
      </div>

      <!-- Car Animation Section -->
      <div class="hero-car-section">
        <picture class="mountain-hero">
          <div class="track-hero">
            <img src="assets/img/login/mountain.png" alt="Mountain">
            <img src="assets/img/login/mountain.png" alt="Mountain">
          </div>
        </picture>
        <picture class="car-scene-hero">
          <div class="car-hero">
            <img src="assets/img/login/car-exausts.png" alt="Car" (click)="explode()">
            <!-- fumaça esquerda -->
            <div class="smoke smoke-left"></div>
            <div class="smoke smoke-left delay"></div>
            <!-- fumaça direita -->
            <div class="smoke smoke-right"></div>
            <div class="smoke smoke-right delay"></div>
            <div class="explosions left" [class.active]="isExploding">
              <span></span><span></span><span></span>
            </div>
            <div class="explosions right" [class.active]="isExploding">
              <span></span><span></span><span></span>
            </div>
          </div>
        </picture>
        <!-- Road/Asphalt -->
        <div class="road-container">
          <div class="road">
            <div class="road-line"></div>
          </div>
        </div>
        <!-- FT Pilot badge -->
        <div class="ftcloud-badge">
          <span>FT<sub>CLOUD</sub></span>
        </div>
      </div>
    </div>
  </section>

  <!-- ABOUT SECTION - O QUE É O FT PILOT? -->
  <section id="about" class="about">
    <div class="container">
      <h2 class="section-title reveal">O QUE É O FT PILOT?</h2>
      <p class="section-intro reveal">
        O FT Pilot é a plataforma digital da FuelTech para gerenciamento de projetos automotivos, onde você pode salvar maps, acessar 
        a loja e aplicar funções nas suas injeções, criar seus projetos e compartilhá-los com a comunidade.
      </p>

      <div class="about-grid">
        <div class="about-image reveal fade-left">
          <div class="mockup-wrapper">
            <img src="assets/img/welcome/welcome.png" alt="Interface Mockup" class="mockup-img">
          </div>
        </div>
        <div class="about-features reveal fade-right">
          <div class="feature-item">
            <span class="bullet-red"></span>
            <div>
              <h3>GERENCIE SEUS PROJETOS</h3>
            </div>
          </div>
          <div class="feature-item">
            <span class="bullet-red"></span>
            <div>
              <h3>LOJA DE PRODUTOS E FUNÇÕES JUSTIFICADAS</h3>
            </div>
          </div>
          <div class="feature-item">
            <span class="bullet-red"></span>
            <div>
              <h3>PROJETOS COMPARTILHADOS - <span class="red-text">TODOS PODEM PARTICIPAR DE EVENTOS</span></h3>
            </div>
          </div>
          <div class="feature-item">
            <span class="bullet-red"></span>
            <div>
              <h3>BACKUP AUTOMÁTICO DE MAPAS E LOGS</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- WHO IS FOR SECTION - PARA QUEM É O FT PILOT? -->
  <section class="who-is-for">
    <div class="container">
      <h2 class="section-title-dark reveal">PARA QUEM É O FT PILOT?</h2>
      <div class="cards-grid-circular">
        <div class="card-circular reveal" style="transition-delay: 0.1s">
          <div class="card-icon-circular">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" stroke-width="1.5">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <h3>USUÁRIOS DE<br>FT700</h3>
          <p>A plataforma ideal para<br>conectar e utilizar funções<br>e melhorar o setup do<br>seu projeto</p>
        </div>
        <div class="card-circular reveal" style="transition-delay: 0.2s">
          <div class="card-icon-circular">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" stroke-width="1.5">
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
            </svg>
          </div>
          <h3>PREPARADORES</h3>
          <p>Profissionais que utilizam<br>produtos FuelTech em<br>seus preparações</p>
        </div>
        <div class="card-circular reveal" style="transition-delay: 0.3s">
          <div class="card-icon-circular">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" stroke-width="1.5">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>
          <h3>ENTUSIASTAS</h3>
          <p>Todos os amantes de<br>carros e que querem<br>participar da<br>comunidade</p>
        </div>
        <div class="card-circular reveal" style="transition-delay: 0.4s">
          <div class="card-icon-circular">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" stroke-width="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="3" y1="9" x2="21" y2="9"></line>
              <line x1="9" y1="21" x2="9" y2="9"></line>
            </svg>
          </div>
          <h3>OFICINAS</h3>
          <p>Uma ferramenta<br>profissional para<br>gerenciar projetos de<br>clientes</p>
        </div>
      </div>
    </div>
  </section>

  <!-- GARAGE SECTION -->
  <section id="garage" class="garage">
    <div class="container">
      <h2 class="section-title white reveal">GARAGEM</h2>
      <p class="section-subtitle reveal">
        Crie seus projetos, adicione fotos, histórico, documentos, geradores e compartilhe com facilidade
        com a comunidade FT Pilot. Uma família unida pelo amor à velocidade.
      </p>

      <div class="projects-filter reveal">
        <span class="filter-label">PROJETOS MAIS VISADOS</span>
      </div>

      <div class="projects-grid">
        <div *ngFor="let project of projects" class="project-card reveal">
          <div class="project-img-wrapper">
            <img [src]="project.primaryImage.length > 0 ? project.primaryImage[0].href : 'assets/img/project/default-project.png'" [alt]="project.projectName" class="project-img">
            <div class="project-overlay">
              <span class="project-label">Acessar Projeto</span>
            </div>
          </div>
          <div class="project-info">
            <span class="project-subtitle">Vamos ver esse projeto?</span>
            <h3>{{ project.projectName }}</h3>
            <button class="btn-project">ACESSAR PROJETO</button>
          </div>
        </div>
        
        <div *ngIf="loadingProjects" class="loading-container">
          <div *ngFor="let i of [1,2,3,4]" class="project-card skeleton">
            <div class="skeleton-img"></div>
            <div class="project-info">
              <div class="skeleton-text"></div>
              <div class="skeleton-text short"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="center-btn reveal">
        <button class="btn-load-more" (click)="loadProjects()">CARREGAR MAIS PROJETOS</button>
      </div>
    </div>
  </section>

  <!-- SHOP SECTION -->
  <section id="shop" class="shop">
    <div class="shop-grid">
      <div class="shop-content reveal fade-left">
        <h2 class="shop-title">LOJA</h2>
        <p class="shop-desc">
          Encontre tudo o que você precisa, upgrade<br>
          de funções para sua injeção e encontre<br>
          na FTShop os melhores equipamentos<br>
          para turbinar seu setup.
        </p>
        <button class="btn-shop">Acessar FTShop</button>
      </div>
      <div class="shop-illustration reveal fade-right">
        <div class="speedometer-container">
          <div class="speedometer-gauge">
            <div class="gauge-display">
              <div class="gauge-value-top">0.88</div>
              <div class="gauge-arc">
                <svg viewBox="0 0 200 120" class="gauge-svg">
                  <path d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="#333" stroke-width="8"/>
                  <path d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="url(#gaugeGradient)" stroke-width="8" stroke-dasharray="251" [attr.stroke-dashoffset]="251 - (gaugeValue * 2.51)"/>
                  <defs>
                    <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" style="stop-color:#00ff00"/>
                      <stop offset="50%" style="stop-color:#ffff00"/>
                      <stop offset="100%" style="stop-color:#ff0000"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div class="gauge-center">
                <div class="gauge-gear">4</div>
                <div class="gauge-rpm">1960</div>
              </div>
              <div class="gauge-start">START</div>
            </div>
            <div class="gauge-labels">
              <span>Pressão voltz</span>
              <span class="gauge-pressure">0</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA FINAL -->
  <section class="cta-final">
    <div class="container reveal">
      <h2 class="cta-title">PRONTO PARA DAR A PARTIDA NO FT PILOT?</h2>
      <button class="btn-cta" (click)="signUp()">VIVA A EXPERIÊNCIA</button>
    </div>
  </section>
</main>

<!-- FOOTER -->
<footer id="footer" class="footer">
  <div class="footer-main">
    <div class="footer-logo-section">
      <img src="assets/img/icone-cloud.svg" alt="FT Pilot" class="footer-logo-icon">
      <span class="footer-logo-text">FT PILOT</span>
    </div>
    
    <nav class="footer-nav">
      <a (click)="scrollToSection('hero')">MINHA GARAGEM</a>
      <a (click)="scrollToSection('about')">COMUNIDADE</a>
      <a (click)="scrollToSection('shop')">LOJA</a>
      <a (click)="scrollToSection('footer')">SUPORTE</a>
      <a>TERMOS DE USO</a>
      <a>POLÍTICA DE PRIVACIDADE</a>
    </nav>

    <div class="footer-right">
      <div class="lang-selector-footer">
        <span>🌐 {{ selectedLanguage.name }}</span>
      </div>
    </div>
  </div>

  <div class="footer-brand">
    <img src="assets/img/logo-FTCloud-white.svg" alt="FuelTech" class="fueltech-logo">
  </div>
  
  <div class="footer-social">
    <a href="#" class="social-icon-footer">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
    </a>
    <a href="#" class="social-icon-footer">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
    </a>
    <a href="#" class="social-icon-footer">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/></svg>
    </a>
    <a href="#" class="social-icon-footer">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
    </a>
  </div>
  
  <div class="footer-bottom">
    <p class="copyright">© 2026 FT PILOT - TODOS OS DIREITOS RESERVADOS - DEVDYNAMICS</p>
  </div>
</footer>
